"use client";

import { PrivyProvider } from '@privy-io/react-auth';

export function PrivyAuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <PrivyProvider
      appId={process.env.REACT_APP_PRIVY_APP_ID!}
      clientId={process.env.REACT_APP_PRIVY_CLIENT_ID!}
      config={{
        loginMethods: ['twitter'],
        appearance: {
          theme: 'light',
        },
      }}
    >
      {children}
    </PrivyProvider>
  );
} 